import { Token } from '@services/types';
import { API_URL } from './index';

let accessToken: Token = JSON.parse(localStorage.getItem('ACCESS_TOKEN') || 'null');

export const setAccessToken = (token: Token) => {
  accessToken = token;
};

const requestWithBody = (method: 'POST' | 'PUT' | 'DELETE') => (url: string, body?: string) =>
  fetch(`${API_URL}${url}`, {
    method,
    body,
    headers: {
      Authorization: accessToken ? `Bearer ${accessToken.token}` : '',
      'Content-Type': 'application/json',
    },
  });

const postRequest = requestWithBody('POST');
const deleteRequest = requestWithBody('DELETE');

const callApi = {
  post: <T = void>(url: string, body?: string): Promise<T> => postRequest(url, body).then((r) => r.json()),
  delete: (url: string, body?: string) => deleteRequest(url, body),
  get: <T = void>(url: string): Promise<T> =>
    fetch(`${API_URL}${url}`, {
      headers: {
        Authorization: accessToken ? `Bearer ${accessToken.token}` : '',
        'Content-Type': 'application/json',
      },
    }).then((r) => r.json()),
};

export default callApi;
